import {
  Shape,
  PlusIcon,
  Loading,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { useListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';

export const AssignProductsToTeam = () => {
  const { data: products, loading } = useListProductDefinitions({
    paginate: { offset: 0, limit: 100 },
  });
  const history = useHistory();
  return (
    <div className="assign-products-to-team">
      {loading && <Loading />}
      {!loading &&
        products?.map((product) => {
          return (
            <button
              key={product.key}
              onClick={() =>
                history.push({
                  search: `assign-requests=${product.key}&name=${product.name}`,
                })
              }
              type="button"
              className="assign-product-card"
            >
              <div className="product-icon">
                {product.name && product.name.substring(0, 2)}
              </div>
              <div className="product-icon-add">
                <PlusIcon fill="var(--tru-white)" width="18px" />
              </div>
              <div className="product-info">
                <h2 className="product-name">{product.name}</h2>
                <p className="product-email">{product.description}</p>
              </div>
              <p className="product-action">
                {product?.requestDefinitionCount! > 1
                  ? `${product.requestDefinitionCount} Requests`
                  : '1 Request'}
                <Shape width="12px" fill="var(--tru-lightgrey)" />
              </p>
            </button>
          );
        })}
      <br />
    </div>
  );
};
